import { compose } from 'redux';
import { connect } from 'react-redux';
import StartView from './StartView';
import AvatarView from '../avatar/avatarView';
import withAvatar from '../avatar/withAvatar';
import { beginAssessment, cacheInstructions, syncOfflineResults } from './startActions';
import selectors from '../../rootSelectors';
import { fetchStudentForms, refreshForms } from '../api/formsActions';
import { setCurrentLanguage, openTRCPracticePopup, closeTRCPracticePopup, hideHelpPopup, showSpinner, showHelpPopup } from '../screen/screenActions';
import { setLocalizationLanguage } from '../localization';
import { logUserOut } from '../user/userActions';
import { syncOfflineAudioForResult  } from '../../trc/trcActions';
import { trackStartAssessment, trackTroError, trackTroVrPopup } from '../../trc/trcReporting';
import { executeApiCallFailedEffect, executeApiCallSucceededEffect, getStudentResults } from '../api/trcoActions';
import { endOfflineAudioSaving, startOfflineAudioSaving } from '../recording/recordingActions';
import { TRO } from '../../constants/measure';
import { setSelectedPassageId } from '../../lc/lcActions';
import { setNextToyPlaylist } from '../playlist/playlistActions';

const mapStateToProps = (state) => ({
    periodFullText: selectors.getCurrentToyFullText(state),
    period: selectors.getToy(state),
    playlist: selectors.getPlaylistItems(state),
    playlistForRender: selectors.getPlaylistItemsForRender(state),
    assessmentType: selectors.getAssessmentType(state),
    isFormsDataFetched: selectors.getIsFormsDataFetched(state),
    isAssessmentCompleted: selectors.getIsAssessmentCompleted(state),
    playlistItemInProgress: selectors.getPlaylistItemInProgress(state),
    nextIncompletePlaylistItem: selectors.getNextIncompleteMeasure(state),
    lastCompletedPlaylistItem: selectors.getLastCompletedMeasure(state),
    currentLanguage: selectors.getCurrentLanguage(state),
    isTRCPracticePopupActive: selectors.getIsTRCPracticePopupActive(state),
    isTRCPracticeAvailable: selectors.getIsTRCPracticeAvailable(state),
    isVrResultProcessing: selectors.getIsVrResultProcessing(state),
    isVrResultUnavailable: selectors.getIsVrResultUnavailable(state),
    isComprehensionComplete: selectors.getIsComprehensionComplete(state),
    resultsVRStatuses: selectors.getVRResultsStatus(state),
    resultVRErrorReasons: selectors.getVRErrorReasons(state),
    isHelpPopupVisible: selectors.getIsHelpPopupVisible(state),
    hasCompletedAllPmForms: selectors.getHasCompletedAllPmForms(state),
    isOfflineAudioSyncInProgress: selectors.getIsOfflineAudioSyncInProgress(state),
    troResult: selectors.findResultFor(state, { measure: TRO.MEASURE, isComplete: false }),
    didApiCallSucceed: selectors.getDidApiCallSucceed(state),
    didApiCallFail: selectors.getDidApiCallFail(state),
    prevApiRequest: selectors.getPrevApiRequest(state),
    grade: selectors.getGrade(state),
    toy: selectors.getToy(state),
    lcPassageId: selectors.getSelectedPassageId(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    isBenchmarkModeEnabled: selectors.getisBenchmarkModeEnabled(state),
    hasNextToy: selectors.getHasNextToy(state),
    studentUid: selectors.getUserId(state),
});

const mapDispatchToProps = (dispatch) => ({
    beginAssessment: () => {
        dispatch(beginAssessment());
    },
    fetchStudentForms: () => {
        dispatch(fetchStudentForms());
    },
    setSelectedPassageId: (id) => {
        dispatch(setSelectedPassageId(id));
    },
    setCurrentLanguage: (language) => {
        dispatch(setCurrentLanguage(language));
        setLocalizationLanguage(language);
    },
    openTRCPracticePopup: () => {
        dispatch(openTRCPracticePopup());
    },
    closeTRCPracticePopup: () => {
        dispatch(closeTRCPracticePopup());
    },
    hideHelpPopup: () => {
        dispatch(hideHelpPopup());
    },
    showSpinner: () => {
        dispatch(showSpinner());
    },
    logUserOut,
    syncOfflineAudio: (shouldRetry) => dispatch(syncOfflineAudioForResult(shouldRetry)),
    getTROResults: () => dispatch(getStudentResults()),
    showAudioSavingPopup: () => {
        dispatch(startOfflineAudioSaving());
        dispatch(showHelpPopup());
    },
    hideAudioSavingPopup: () => {
        dispatch(hideHelpPopup());
        dispatch(endOfflineAudioSaving());
    },
    executeApiCallSucceededEffect: (prevApiRequest, resultId) => dispatch(executeApiCallSucceededEffect({
        prevApiRequest,
        resultId,
    })),
    executeApiCallFailedEffect: (prevApiRequest, resultId) => dispatch(executeApiCallFailedEffect({
        prevApiRequest,
        resultId,
    })),
    setNextToyPlaylist: () => dispatch(setNextToyPlaylist()),
    trackStartAssessment: () => dispatch(trackStartAssessment()),
    trackTroError: errorMessage => dispatch(trackTroError(errorMessage)),
    trackTroVrPopup: problemText => dispatch(trackTroVrPopup(problemText)),
    refreshForms: () => dispatch(refreshForms()),
    syncOfflineResults: () => dispatch(syncOfflineResults()),
    cacheInstructions: (nextMeasure) => dispatch(cacheInstructions(nextMeasure)),
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.START_MIDDLE_LEFT,
});

const StartContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(StartView);

export default StartContainer;
